/**
 * Formatage partagé par l'Event Monitor et le State Bag Monitor.
 */
export const fmtNum = (n: number | null | undefined, digits = 2) => {
    if (n === null || n === undefined || !Number.isFinite(n)) return '–';
    if (n === 0) return '0';
    const abs = Math.abs(n);
    if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
    if (abs >= 10_000) return `${(n / 1000).toFixed(1)}k`;
    if (abs >= 100) return Math.round(n).toString();
    if (abs >= 1) return n.toFixed(Math.min(digits, 1)).replace(/\.0$/, '');
    return n.toFixed(digits).replace(/0+$/, '').replace(/\.$/, '');
};

export const fmtBytes = (b: number | null | undefined) => {
    if (b === null || b === undefined || !Number.isFinite(b)) return '–';
    if (b < 1024) return `${Math.round(b)} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(b < 10 * 1024 ? 1 : 0)} KiB`;
    if (b < 1024 * 1024 * 1024) return `${(b / 1024 / 1024).toFixed(1)} MiB`;
    return `${(b / 1024 / 1024 / 1024).toFixed(2)} GiB`;
};

export const fmtMs = (ms: number | null | undefined) => {
    if (ms === null || ms === undefined || !Number.isFinite(ms)) return '–';
    if (ms === 0) return '0 ms';
    if (ms < 0.01) return '<0.01 ms';
    if (ms < 10) return `${ms.toFixed(2)} ms`;
    if (ms < 1000) return `${ms.toFixed(1)} ms`;
    return `${(ms / 1000).toFixed(2)} s`;
};

export const fmtAgo = (ts: number | null | undefined, now = Date.now()) => {
    if (!ts) return 'never';
    const s = Math.max(0, Math.round((now - ts) / 1000));
    if (s < 5) return 'just now';
    if (s < 60) return `${s}s ago`;
    const m = Math.floor(s / 60);
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ${m % 60}m ago`;
    return `${Math.floor(h / 24)}d ago`;
};

export const fmtDateTime = (ts: number | null | undefined) => {
    if (!ts) return '–';
    return new Date(ts).toLocaleString(undefined, {
        month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
};

export const fmtTime = (ts: number, withDate = false) => new Date(ts).toLocaleString(undefined, withDate
    ? { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }
    : { hour: '2-digit', minute: '2-digit', second: '2-digit' });
